<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="37em"
    max-height="34em"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        @click="sendReload"
        class="button"
        width="16em"
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-icon v-bind="attrs" color="white" v-on="on">mdi-map</v-icon>
        <span class="color-white"> SELECCIONAR EN MAPA </span>
      </v-btn>
    </template>
    <template v-slot:default="dialog">
      <v-card class="full">
        <v-toolbar class="titleBox"> Configurar Zona </v-toolbar>
        <Map class="lt-map elevation-2 rounded-lg" />
        <MapUi />
      </v-card>
      <v-toolbar class="text-right">
        <v-btn rounded text @click="dialog.value = false">
          CERRAR
        </v-btn>
      </v-toolbar>
    </template>
  </v-dialog>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
import Map from '../map/Map.vue'
import MapUi from '../map/MapUi.vue'
import Dialog from '@/components/dialog/Dialog'

export default {
  name: 'CreateZoneModal',
  components: {
    SvgIcon,
    Map,
    MapUi,
    Dialog
  },
  data() {
    return {
      dialog: false
    }
  },
  props: {
    sendReload: Function,

    zonesList: {
      type: Array
    }
  },
  mounted() {
    //this.initMapState()
    //this.showSearchInput()
  },
  updated() {
    //this.showSearchInput()
  }
}
</script>

<style scoped>
.v-overflow-btn .v-input__slot::before {
  border-color: transparent;
}
.map {
  justify-content: center;

  display: flex;
  flex: 1;
  min-height: 30em;
  min-width: 40em;
  align-self: center;
}

.button {
  height: 3.1em;
  background-color: #0083ff;
  display: flex;
  justify-content: space-evenly;
  border-radius: 2em;
}

.btn-cerrar {
  border-radius: 1em;
  border-width: 1px;
  border-color: black;
  border-style: groove;
  width: 6.75em;
  height: 1.1em;
  position: absolute;
  bottom: 1.4em;
  right: 9em;
  font-family: 'Lato';
  font-size: 12px;
}

.btn-guardar {
  border-radius: 1em;
  border-width: 1px;
  background-color: #0083ff;
  color: white;
  width: 6.75em;
  height: 1.1em;
  position: absolute;
  bottom: 1.4em;
  right: 1em;
  font-size: 12px;
}

.buttonBox {
  width: 37em;
  padding-bottom: 0.2em;
  padding-top: 0.2em;
  background-color: #d7dce0;
  color: #0a2463;
  border-top-style: solid;
  border-top-color: #d7dce0;
}
.titleBox {
  width: 37em;
  padding-bottom: 0.2em;
  padding-top: 0.2em;
  background-color: #d7dce0;
  color: #0a2463;
  border-bottom-style: solid;
  border-bottom-color: #d7dce0;
}

.full {
  width: 100%;
  height: 31.25em;
  margin: 0 auto;
}
.lt-map {
  height: 100%;
  @media screen and (max-width: 960px) {
    height: 100vh;
  }
}
.fill-height-or-more {
  display: flex;
  flex-direction: column;
}

.color-white {
  color: white;
  font-family: 'Lato';
  font-size: 0.9em;
}
</style>
